import { Request } from "@tools/base";;
const { Axios } = Request;

const URL = "/v1/equity/market/public/";

//获取交易对
export function get_symbol(config?) {
  return Axios.get(URL + `symbol`, config);
}

//获取24h行情统计
export function get_ticker24h(config?) {
  return Axios.get(URL + `ticker/24h`, config);
}

//获取排行榜配置
export function get_topConfig(config?) {
  return Axios.get(URL + `top/config`, config);
}

//获取所有板块
export function get_plate(config?) {
  return Axios.get(URL + `plate`, config);
}

//查询近期成交列表
export function get_tradeRecent(config?) {
  return Axios.get(URL + `trade/recent`, config);
}

//获取深度信息
export function get_depth(config?) {
  return Axios.get(URL + `depth`, config);
}

//获取服务器时间
export function get_time(config?) {
  return Axios.get(URL + `time`, config);
}

//获取K线数据
export function get_kline(config) {
  return Axios.get(URL + `kline`, config);
}

//获取交易市场taker、maker费率
export function get_symbolFeeRate(config) {
  return Axios.get(URL + `symbol/fee-rate`, config);
}

//获取杠杆交易对
export function get_leverSymbol(config?) {
  return Axios.get(URL + `lever/symbol/tenant`, config);
}

//获取etf交易对列表
export function get_etf_list(config?) {
  return Axios.get(URL + `etf/symbol`, config);
}

//获取净值
export function get_net_worth(symbolId, config?) {
  return Axios.get(URL + `etf/symbol/net-worth/${symbolId}`, config);
}

//获取市场状态
export function get_market_state(config?) {
  return Axios.get(URL + `market/state`, config);
}

//获取单个股票状态
export function get_equity_state(config?) {
  return Axios.get(URL + `equity/state`, config);
}

//获取券商下载链接
export function get_broker_link(config?) {
  return Axios.get(URL + `global/config`, config);
}
